import { ZusatzoptionItem } from '@ps20-frontend/frontend-models';

export enum ZusatzoptionenNameRSEnum {
  STRAFRECHTSSCHUTZ = 'STRAFRECHTSSCHUTZ',
  VERMIETER = 'VERMIETER',
}

export interface ZusatzoptionItemRS extends ZusatzoptionItem {
  name: ZusatzoptionenNameRSEnum | string;
}
